export const validateTaxIdNumber = (id: string) => {
  if (!id) return true;
  if (!/^\d{8}$/.test(id)) return false;

  const multipliers = [1, 2, 1, 2, 1, 2, 4, 1];
  const sum = id.split("").reduce((acc, char, index) => {
    let product = parseInt(char) * multipliers[index];
    return acc + Math.floor(product / 10) + (product % 10);
  }, 0);

  // 財政部 2023-04 新版檢核：總和可被 5 整除即有效（舊版為 10）
  if (sum % 5 === 0) return true;
  if (id[6] === "7" && (sum + 1) % 5 === 0) return true;

  return false;
};
